import { createSelector } from 'reselect'
import featureScopesSelector from './featureScopesSelector'

const isSaveVehicleCodeVisibleSelector = createSelector(featureScopesSelector, (featureScopes): boolean =>
   !featureScopes.includes('hideSaveVehicleCode'),
)

export default isSaveVehicleCodeVisibleSelector
